import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsGlobalPermissionsRoute: InvariantJiraRoute = {
	name: 'global-settings-global-permissions',
	path: '/secure/admin/global-permissions',
};
